<template>
  <div class="container-fluid" id="contacto">
  <div class="col-md-12 flecha-container">  
  <h1 data-aos="fade-up"  data-aos-duration="1500">CONTACTO</h1>
    <img data-aos="fade-right"  data-aos-duration="1500" class="flecha" src="~imgs/icons/Flecha_Blanca.png">
  </div>
    <div class="row contact-container">
      <div  class="col-md-6">
      <div data-aos="fade-up"  data-aos-duration="1500" class="contact-info">
      <img src="~imgs/icons/Contacto_Locaction.png">
      <p >Encuéntranos<br>
       Blvd. Abelardo L. Rodríguez #828<br>
       Colonia Compuertas C.P. 21218<br>
       Mexicali, B.C.</p>
       </div>
       <div data-aos="fade-up"  data-aos-duration="1500" class="contact-info">
      <img src="~imgs/icons/Contacto_Telefono.png">
      <p>Llámanos<br>
          Tel: 686-5657663 <br>
          Lada sin costo Nacional: 01-800 7880152<br>
          Lada sin costo Internacional: (011)(52)855-7550643</p>
      </div>
      </div>
      <div data-aos="fade-up"  data-aos-duration="1500" class="col-md-6 right-contact-container">
      <h4>¿Tienes preguntas? <br>Estamos para servirte. </h4>
      <form id="contacto-aa" action="send_mail.php" method="post" enctype='multipart/form-data'>
       <p>Nombre Completo</p>
        <c-input type="text"  name="names" val="names"></c-input>
        <p>E-Mail</p>
        <c-input type="email" name="email" val="email"> </c-input>
        <p>Teléfono</p>
        <c-input type="tel" name="tel" val="tel"> </c-input>
        <p>Mensaje</p>
        <textarea type="text" name="comment" val="comment">  
        </textarea>  
      </form>
      <btn-submit classtype="btn-default" message="Enviar"></btn-submit>
      </div>
     </div>
     <div id="footer">
       Copyright @2017 All Rights Reserved
     </div>
  </div>
</template>

<script>
import CInput from './reusable/Input.vue'
import BtnSubmit from './reusable/ButtonSubmit.vue'
import Arrow from './reusable/ArrowRight.vue'
export default{
  data(){
    return{

    }
  },
  props:['name', 'selector'],
  components: {
    Arrow,
    CInput,
    BtnSubmit
  }
}


</script>

<style lang="scss" scoped>
@import '~varmix';
#contacto{
  height: 100%;
  height: 100%;
  background-color:#000;
  color:white;
  text-align:center;
}
.contact-container{
  margin:40px 0 40px 0;
}
.left-contact-container{
  width:40%;
  display:inline-block;
 
}
.contact-info{
  width:100%;
  text-align:center;
}
.encuentranos-div{
  font-size:12pt;
}
.contact-info img{
  margin-top:40px;
  margin-bottom:20px;
  width:10%;
  text-align:center;
}
.left-contact-container p{
  margin:0px 0 20px 0;
}
.left-contact-container img{
  margin:20px 0 20px 0;
  width:70px;
}
.right-contact-container{
    display:inline-block;
    margin:auto;
    text-align:justify;
}

.right-contact-container form{
  margin:auto;
  width:100%;
  margin-top:40px;
}
.right-contact-container input{
  width:100%;
  max-width:420px;
  margin:auto;
  margin-bottom:10px;
}
.right-contact-container textarea{
  width:100%;
  max-width:420px;
  height:150px;
    margin:auto;

}
.right-contact-container h4{
text-align:center;
  max-width:420px;

}
.flecha-container{
  width:100%;
  text-align:left;
}
.flecha-container h1{
float:right;
margin-right:20px;
margin-top:20px;

font-size:30pt;
}
.flecha{
margin-left:-30px;
margin-top:20px;
width:80%;
}

#footer{
  background-color:$red;
  width:100%;
  padding:0px;
}

button{
  background-color:$red;
  color:white;
  border:0px solid;
  margin-top:10px;
  width:100%;
  max-width:420px;
    outline:none;

}

button:active{
  background-color:$dark-red;
  border:0px solid;
  outline:none;
  padding:3px;
}

textarea{
  color:black;
  outline:none;
}


</style>



// WEBPACK FOOTER //
// contacto.vue?ab8deb9c